"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleLoadDropFiles = exports.handleInitiate = exports.initSpectra = exports.handleSetIsLoading = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const mergeWith_1 = __importDefault(require("lodash/mergeWith"));
const nmr_correlation_1 = require("nmr-correlation");
const Spectrum1D_1 = require("../../../data/data1d/Spectrum1D");
const Spectrum2D_1 = require("../../../data/data2d/Spectrum2D");
const MoleculeManager = __importStar(require("../../../data/molecules/MoleculeManager"));
const linkMetaWithSpectra_1 = require("../../../data/parseMeta/linkMetaWithSpectra");
const Constants_1 = require("../../panels/SummaryPanel/CorrelationTable/Constants");
const nucleusToString_1 = __importDefault(require("../../utility/nucleusToString"));
const Reducer_1 = require("../Reducer");
const PreferencesActions_1 = require("./PreferencesActions");
const SpectrumsActions_1 = require("./SpectrumsActions");
const ToolsActions_1 = require("./ToolsActions");
function convertHybridizationStringValuesInCorrelations(correlations) {
    return {
        ...correlations,
        values: correlations.values.map((correlation) => {
            if (typeof correlation.hybridization === 'string') {
                const values = [];
                if (correlation.hybridization.length > 0) {
                    const hybridizationString = correlation.hybridization.replaceAll('SP', '');
                    const value = Number(hybridizationString);
                    values.push(value);
                }
                correlation.hybridization = values;
            }
            return correlation;
        }),
    };
}
function setCorrelation(draft, correlations) {
    if (!correlations || Object.keys(correlations).length === 0) {
        draft.correlations = (0, nmr_correlation_1.buildCorrelationData)([], {
            tolerance: Constants_1.DefaultTolerance,
        });
    }
    else {
        // in case of older NMRium data are imported, convert hybridization string to number array
        // @TODO remove following command to overwrite correlations at some point in future
        draft.correlations =
            convertHybridizationStringValuesInCorrelations(correlations);
        // draft.correlations = correlations // original command without overwriting
    }
}
function setData(draft, input, options = {}) {
    const { nmriumState: { data, view }, onLoadProcessing = {}, parseMetaFileResult = null, } = input || {
        nmriumState: { data: { spectra: [], molecules: [], correlations: {} } },
        multipleAnalysis: {},
    };
    const { autoOnLoadProcessing = true } = options;
    const { source, spectra = [], molecules = [], correlations = {}, } = data || {};
    if (view) {
        const defaultViewState = (0, Reducer_1.getDefaultViewState)();
        draft.view = (0, merge_1.default)(defaultViewState, view);
    }
    if (source) {
        draft.source = (0, mergeWith_1.default)(draft.source, source, (objValue, srcValue) => {
            if (Array.isArray(objValue)) {
                return objValue.concat(srcValue);
            }
        });
    }
    draft.molecules = draft.molecules.concat(MoleculeManager.fromJSON(molecules, draft.molecules));
    draft.data = draft.data.concat(initSpectra(spectra, {
        usedColors: draft.usedColors,
        onLoadProcessing: autoOnLoadProcessing ? onLoadProcessing : {},
        molecules: draft.molecules,
    }));
    setCorrelation(draft, correlations);
    if (parseMetaFileResult) {
        const { matches } = (0, linkMetaWithSpectra_1.linkMetaWithSpectra)({
            autolink: true,
            spectra: draft.data,
            parseMetaFileResult,
        });
        (0, SpectrumsActions_1.setSpectraMetaInfo)(draft, matches);
    }
}
function initSpectra(inputSpectra, options) {
    const spectra = [];
    const { usedColors, onLoadProcessing, molecules } = options;
    for (const spectrum of inputSpectra) {
        const { info } = spectrum;
        if (info.dimension === 1) {
            const filters = onLoadProcessing?.[(0, nucleusToString_1.default)(info.nucleus)] || [];
            spectra.push((0, Spectrum1D_1.initiateDatum1D)(spectrum, { usedColors, filters, molecules }));
        }
        else if (info.dimension === 2) {
            spectra.push((0, Spectrum2D_1.initiateDatum2D)({ ...spectrum }, { usedColors }));
        }
    }
    return spectra;
}
exports.initSpectra = initSpectra;
function setPreferences(draft, data) {
    const emptyPreferences = {
        verticalAlign: null,
    };
    const { verticalAlign = null } = data || emptyPreferences;
    const vAlign = verticalAlign?.[draft.view.spectra.activeTab];
    if (vAlign) {
        (0, PreferencesActions_1.changeSpectrumVerticalAlignment)(draft, {
            verticalAlign: vAlign,
        });
    }
    else {
        (0, PreferencesActions_1.changeSpectrumVerticalAlignment)(draft, { verticalAlign: 'auto-check' });
    }
}
function initData(draft, action, options = {}) {
    const { forceInitialize = false, autoOnLoadProcessing = true } = options;
    const { nmriumState: { data, view }, } = action.payload;
    const viewState = view;
    if (data?.spectra?.length || forceInitialize) {
        const state = (0, Reducer_1.getInitialState)();
        setData(state, action.payload, { autoOnLoadProcessing });
        (0, ToolsActions_1.setActiveTab)(state, { tab: viewState?.spectra?.activeTab || '' });
        state.width = draft.width;
        state.height = draft.height;
        setPreferences(state, viewState);
        state.isLoading = false;
        state.actionType = action.type;
        return state;
    }
    else {
        if (view) {
            const defaultViewState = (0, Reducer_1.getDefaultViewState)();
            draft.view = (0, merge_1.default)(defaultViewState, view);
        }
        draft.actionType = action.type;
        draft.isLoading = false;
    }
}
//action
function handleSetIsLoading(draft, action) {
    draft.isLoading = action.payload.isLoading;
}
exports.handleSetIsLoading = handleSetIsLoading;
//action
function handleInitiate(draft, action) {
    return initData(draft, action, {
        forceInitialize: true,
        autoOnLoadProcessing: false,
    });
}
exports.handleInitiate = handleInitiate;
//action
function handleLoadDropFiles(draft, action) {
    const { payload, type } = action;
    const { nmriumState: { data: { spectra = [] } = {} }, containsNmrium = false, resetSourceObject = true, } = payload;
    if (containsNmrium) {
        return initData(draft, action, { autoOnLoadProcessing: false });
    }
    else {
        setData(draft, payload);
        (0, ToolsActions_1.setActiveTab)(draft);
        (0, PreferencesActions_1.changeSpectrumVerticalAlignment)(draft, { verticalAlign: 'auto-check' });
        // set source undefined when dragging and dropping a spectra file to prevent export spectra with the data source.
        if (resetSourceObject && spectra?.length > 0) {
            draft.source = undefined;
        }
        draft.actionType = type;
        draft.isLoading = false;
    }
}
exports.handleLoadDropFiles = handleLoadDropFiles;
